<div class="gray-bg-rounded">
  <label for="file-upload" class="btn-choice">
    <span class="d-block">Attachment:</span>
    <p-fileupload
      [multiple]="true"
      customUpload
      (uploadHandler)="getAttachmentFile($event)"
      (onClear)="onFileClickRemove()"
      class="ms-3 jni-fileupload-hidden"
      #fileEvent
      [auto]="true"
      [showUploadButton]="false"
      [showCancelButton]="false"
      chooseLabel=""
      [chooseIcon]="''"
      accept="image/*, .doc, .txt, .xls, .pdf, .docx, .csv, .xlsx, .pptx, .eps, .esp, .ai">
      <ng-template
        pTemplate="content"
        let-files
        let-chooseCallback="chooseCallback">
        <div
          class="po-attachment-drag-drop-container"
          (dragover)="onDragOver($event)"
          (drop)="onFileDrop($event)"
          (dragleave)="onDragLeave($event)"
          (dragenter)="onDragEnter($event)">
          <div
            class="po-attachment-drag-drop-area"
            [class.drag-over]="isDragOver">
            <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
            <div class="po-attachment-drag-drop-text">
              <p class="mb-2">Drag & Drop files here</p>
            </div>
          </div>
          <!-- File preview is handled below by filesObject array, so we don't need the p-fileupload internal preview -->
        </div>
      </ng-template>
    </p-fileupload>
  </label>

  <div class="box-card input-files mt-2">
    <div class="d-flex justify-content-between mb-6" *ngIf="fileName">
      <div>
        <a style="cursor: pointer">
          <span data-toggle="tooltip" title="pdf">
            {{ fileName }}
          </span>
        </a>
        <span></span>
      </div>
      <span> </span>
    </div>

    <div
      class="d-flex justify-content-between mb-6 globalborder-btm-header align-items-center"
      *ngFor="let file of filesObject; let in = index">
      <div class="mb-2">
        <a
          class="has-link"
          style="cursor: pointer"
          (click)="onViewAttachment(file)">
          <span data-toggle="tooltip" title="{{ file.fileName }}">
            {{ file.fileName }}
          </span>
        </a>
        <span>{{ file.fileSizeName }}</span>
      </div>

      <a (click)="fileRemove(file)">
        <i class="pi pi-times"></i>
      </a>
    </div>
  </div>
</div>
